"use client";

import { Button, Dropdown, Form } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import * as myApi from "../../../Api";

const Profile = ({ user }) => {
  const location = useLocation(); // Use `useLocation` to get the current path
  const pathname = location.pathname; // Extract `pathname` from location

  const handleLogout = (event) => {
    event.preventDefault();
    myApi.removeUser();
    myApi.removeToken();
    window.location.href = myApi.loginPath;
  }

  return (
    <>
      <Dropdown className="admin-profile">
        <Dropdown.Toggle className="d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor">

          <div className="flex-grow-1 ms-2">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-none d-xxl-block">
                <div className="d-flex align-content-center">
                  <h3>{user.name.slice(0, 3).toUpperCase()}</h3>
                </div>
              </div>
            </div>
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu className="border-0 bg-white dropdown-menu-end" style={{ maxWidth: '400px', width: 'auto' }}>
          <div className="d-flex align-items-center info">
            <div className="flex-shrink-0">
              <i className="material-symbols-outlined fs-1">account_circle</i>
            </div>
            <div className="flex-grow-1 ms-2" style={{ minWidth: 0 }}>
              <h3 className="fw-medium mb-0 text-truncate" style={{ fontSize: '14px', maxWidth: '100%' }}>{user.name}</h3>
              <span className="fs-12 text-truncate d-block" style={{ maxWidth: '100%' }}>{user.email}</span>
            </div>
          </div>

          <ul className="admin-link ps-0 mb-0 list-unstyled">
            <li>
              <Link
                to="/profile"
                className={`dropdown-item d-flex align-items-center text-body ${
                  pathname === "/profile" ? "activeLink" : ""
                }`}
              >
                <i className="material-symbols-outlined">person</i>
                <span className="ms-2">My Profile</span>
              </Link>
            </li>

            <li>
              <Form onSubmit={handleLogout}>
                <Button type="submit" className="dropdown-item d-flex align-items-center text-body">
                  <i className="material-symbols-outlined">logout</i>
                  <span className="ms-2">Logout</span>
                </Button>
              </Form>
            </li>
          </ul>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default Profile;
